import { ITile } from './Interfaces';

export default class Tile implements ITile {
  private notes: number[] = [];
  private numberOfNotes = 0;

  isEmpty(): boolean {
    return this.numberOfNotes === 0;
  }

  getNote(i: number): number {
    return this.notes[i];
  }

  getBitmask(): number {
    return this.notes.reduce(
      // eslint-disable-next-line no-bitwise
      (acc, curNote, i) => (typeof curNote !== 'undefined' ? acc + (1 << i) : acc),
      0,
    );
  }

  hasNote(i: number): boolean {
    return typeof this.notes[i] !== 'undefined';
  }

  addNote(i: number, noteId: number): void {
    this.notes[i] = noteId;
    this.numberOfNotes += 1;
  }

  removeNote(i: number): void {
    delete this.notes[i];
    this.numberOfNotes -= 1;
  }

  removeAllNotes(): void {
    this.notes = [];
    this.numberOfNotes = 0;
  }
}
